import { createPlatformErrorReporter } from "@opencloud/agent-protocol";

const root = typeof document === "undefined" ? null : document.querySelector<HTMLElement>("#root");
const identifier = /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/gi;

/** Agent chat errors reach the platform issue tracker through the Agent service. */
export const agentErrorReporter = createPlatformErrorReporter({
  endpoint: "/v1/platform-errors/reports",
  source: "agent_ui",
  release: root?.dataset.release ?? null,
  route: () => (typeof location === "undefined" ? null : location.pathname.replace(identifier, "/:id")),
});

let enabled = false;

/** Called once from the entry point; tests and fixtures never report. */
export function enableAgentErrorReporting(): void {
  if (enabled) return;
  enabled = true;
  agentErrorReporter.install();
}

export function reportAgentApiFailure(failure: { status: number; code: string; requestId: string | null; method: string; path: string }): void {
  if (!enabled || failure.status < 500) return;
  agentErrorReporter.reportApiFailure({ ...failure, path: failure.path.replace(identifier, "/:id") });
}
